module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou14-608014cc77c44c0ddf0e937dbf559409.jpg";